import { SVGAttributes } from 'react'

export default function ProcurementIcon(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
			<path d="M47.798 47.798c-10.935 10.936-28.66 10.936-39.596 0-10.936-10.935-10.936-28.66 0-39.596 10.935-10.936 28.66-10.936 39.596 0 10.936 10.935 10.936 28.66 0 39.596z" fill="#363940"/>
			<path d="M28.002 37.586L17.77 34.13V21.871l10.232 3.463v12.252z" fill="#C6C8CF"/>
			<path d="M34.278 23.218l-10.227-3.467-2.315.778 10.188 3.517v2.36l2.354-.793v-2.395z" fill="#8BC53F"/>
			<path d="M34.593 23.093l3.636-1.217-10.227-3.462-3.572 1.207 10.163 3.472zM21.307 20.679l-3.537 1.192 10.232 3.463 3.577-1.138-10.272-3.517z" fill="#fff"/>
			<path d="M34.593 23.093v2.74l-3.014 1.027v-2.664l-3.577 1.137v12.253L38.23 34.13V21.876l-3.637 1.217z" fill="#C6C8CF"/>
			<path d="M27.962 48.427c-1.561 0-3.133-.18-4.69-.554l.52-2.18c7.837 1.87 16.084-1.726 20.055-8.75a18.15 18.15 0 00-3.293-22.121l1.542-1.626a20.392 20.392 0 013.697 24.85c-3.667 6.495-10.587 10.38-17.83 10.38z" fill="#fff"/>
			<path d="M37.511 11.19l6.965 1.906-2.919 1.202-.409 3.133-3.637-6.241z" fill="#fff"/>
			<path d="M13.924 42.8a20.392 20.392 0 01-3.697-24.85c4.475-7.922 13.77-11.953 22.6-9.808l-.53 2.175c-7.861-1.91-16.133 1.681-20.12 8.73a18.15 18.15 0 003.293 22.121L13.925 42.8z" fill="#C6C8CF"/>
			<path d="M18.514 44.81l-6.97-1.906 2.924-1.202.404-3.133 3.642 6.24z" fill="#C6C8CF"/>
		</svg>
	)
}


